import React from 'react';

import './cmsUserCreate.css';
import CmsUserForm from '../CmsUserForm';

export function CmsUserCreate() {
    return <CmsUserForm isEdit={false} />;
}
